import React, { Fragment } from 'react';
import DuplicateQuizAction from './DuplicateQuizAction';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const EditOptions = ({
  isAssigned,
  isInProgress,
  onSubmit,
  onClose = () => {},
  assessmentId = '',
}) => {
  let modalTitle = '';
  let modalContent = null;
  let modalSubmitButtonText = '';
  let modalCloseButtonText = '';

  const inProgressAndAssigned = isAssigned && isInProgress;

  const duplicateText = (
    <span>
      To edit a new version you can assign to students, you can
      <DuplicateQuizAction
        tagName="span"
        assessmentId={assessmentId}
        onClose={onClose}
      />
    </span>
  );

  if (!isAssigned) {
    onSubmit();
  } else if (!isInProgress) {
    modalTitle = 'Editing All Assignments';
    modalContent = (
      <Fragment>
        <p>
          Any edits you make to this assessment will be applied to all assigned
          versions.
        </p>
        <p>{duplicateText}</p>
      </Fragment>
    );
    modalSubmitButtonText = 'Continue Editing';
    modalCloseButtonText = 'Cancel';
  } else {
    modalTitle = 'Already In Progress';
    modalContent = (
      <Fragment>
        <p>
          You cannot edit an assessment that any student has started or
          completed, or that is currently open to students.
        </p>
        <p>
          To keep additional students from taking this assessment, you can lock
          and mark this assignment complete.
        </p>
        <p>{duplicateText}</p>
      </Fragment>
    );
    modalSubmitButtonText = 'Close';
  }

  return (
    <ConfirmDialog
      size="tiny"
      title={modalTitle}
      onClose={onClose}
      onSuccess={() => (inProgressAndAssigned ? onClose() : onSubmit())}
      content={{
        btnPrimary: modalSubmitButtonText,
        btnSecondary: modalCloseButtonText,
      }}
    >
      {modalContent}
    </ConfirmDialog>
  );
};

export default EditOptions;
